import { Box, InputBase, Typography } from "@mui/material";
import React, { useMemo } from "react";

export default function TableQuestion({ question, formData, setFormData }) {
  const columns = question.headers.length - 1;

  const tableAnswers = useMemo(() => {
    return formData.filter((x) => x.questionId === question.id);
  }, [formData, question.id]);
  const getValue = (row, col) => {
    return (
      formData.find(
        (x) =>
          x.questionId === question.id &&
          x.rowIndex === row &&
          x.columnIndex === col,
      )?.answer ?? ""
    );
  };

  const handleChange = (row, col, value) => {
    setFormData((prev) => {
      const index = prev.findIndex(
        (x) =>
          x.questionId === question.id &&
          x.rowIndex === row &&
          x.columnIndex === col,
      );

      if (index !== -1) {
        const clone = [...prev];

        clone[index] = {
          ...clone[index],
          answer: value,
        };

        return clone;
      }

      return [
        ...prev,
        {
          questionId: question.id,
          rowIndex: row,
          columnIndex: col,
          answer: value,
        },
      ];
    });
  };

  return (
    <Box>
      <Typography
        textAlign="center"
        fontWeight="bold"
        color="var(--emr-red)"
        mb={2}
      >
        {question.title}
      </Typography>

      <Box>
        <Box display="flex" py={1} borderBottom="1px solid #eee">
          {question.headers.map((header) => (
            <Typography key={header} width="100%" textAlign="center">
              {header}
            </Typography>
          ))}
        </Box>

        {question.firstColumn.map((title, row) => (
          <Box key={row} display="flex" py={1} borderBottom="1px solid #eee">
            <Typography width="100%" textAlign="center">
              {title}
            </Typography>

            {question.headers.slice(1).map((_, col) => (
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                key={col}
              >
                <InputBase
                  value={getValue(row, col)}
                  onChange={(e) => handleChange(row, col, e.target.value)}
                  sx={{
                    width: "70%",
                    border: "1px solid #999",
                    borderRadius: 1,
                    px: 1,
                  }}
                />
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
